export const LIST_MAPPING_PATIENT_REQUEST = 'LIST_MAPPING_PATIENT_REQUEST'
export const LIST_MAPPING_PATIENT_SUCCESS = 'LIST_MAPPING_PATIENT_SUCCESS'
export const LIST_MAPPING_PATIENT_FAIL = 'LIST_MAPPING_PATIENT_FAIL'
export const LIST_MAPPING_PATIENT_RESET = 'LIST_MAPPING_PATIENT_RESET'

export const CREATE_MAPPING_PATIENT_REQUEST = 'CREATE_MAPPING_PATIENT_REQUEST'
export const CREATE_MAPPING_PATIENT_SUCCESS = 'CREATE_MAPPING_PATIENT_SUCCESS'
export const CREATE_MAPPING_PATIENT_FAIL = 'CREATE_MAPPING_PATIENT_FAIL'

export const HISTORY_MAPPING_PATIENT_REQUEST = 'HISTORY_MAPPING_PATIENT_REQUEST'
export const HISTORY_MAPPING_PATIENT_SUCCESS = 'HISTORY_MAPPING_PATIENT_SUCCESS'
export const HISTORY_MAPPING_PATIENT_FAIL = 'HISTORY_MAPPING_PATIENT_FAIL'

export const LIST_MAPPING_PATIENT_BY_PATIENT_ID_SUCCESS =
  'LIST_MAPPING_PATIENT_BY_PATIENT_ID_SUCCESS'
export const LIST_MAPPING_PATIENT_BY_PATIENT_ID_REQUEST =
  'LIST_MAPPING_PATIENT_BY_PATIENT_ID_REQUEST'
export const LIST_MAPPING_PATIENT_BY_PATIENT_ID_FAIL =
  'LIST_MAPPING_PATIENT_BY_PATIENT_ID_FAIL'
export const DETAIL_MAPPING_PATIENT_REQUEST = 'DETAIL_MAPPING_PATIENT_REQUEST'
export const DETAIL_MAPPING_PATIENT_SUCCESS = 'DETAIL_MAPPING_PATIENT_SUCCESS'
export const DETAIL_MAPPING_PATIENT_FAIL = 'DETAIL_MAPPING_PATIENT_FAIL'

export const UPDATE_MAPPING_PATIENT_REQUEST = 'UPDATE_MAPPING_PATIENT_REQUEST'
export const UPDATE_MAPPING_PATIENT_SUCCESS = 'UPDATE_MAPPING_PATIENT_SUCCESS'
export const UPDATE_MAPPING_PATIENT_FAIL = 'UPDATE_MAPPING_PATIENT_FAIL'

export const DELETE_MAPPING_PATIENT_REQUEST = 'DELETE_MAPPING_PATIENT_REQUEST'
export const DELETE_MAPPING_PATIENT_SUCCESS = 'DELETE_MAPPING_PATIENT_SUCCESS'
export const DELETE_MAPPING_PATIENT_FAIL = 'DELETE_MAPPING_PATIENT_FAIL'

export const RESET_MAPPING_PATIENT = 'RESET_MAPPING_PATIENT'
